import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'antd/dist/reset.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
/** Light theme only until dark mode is re-enabled (see ThemeToggle / theme slice). */
function ThemeRoot() {
  useEffect(() => {
    document.documentElement.classList.remove('dark');
  }, []);
  return <App />;
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeRoot />
    </Provider>
  </React.StrictMode>
);

